import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagOM = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M0 25c0 9.476 5.272 17.72 13.043 21.96V3.04C5.273 7.28 0 15.524 0 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M48.445 33.696A24.946 24.946 0 0 0 50 25c0-3.058-.55-5.988-1.555-8.696H1.555A24.944 24.944 0 0 0 0 25c0 3.058.55 5.987 1.555 8.696L25 35.869l23.445-2.173Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M25 50c10.75 0 19.913-6.784 23.446-16.304H1.556C5.087 43.216 14.25 50 25 50Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M0 25c0 11.55 7.834 21.27 18.478 24.138V.86C7.834 3.73 0 13.448 0 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M15.294 11.001 12.99 8.696l-1.538 1.537-1.537-1.537L7.61 11l1.537 1.538-1.538 1.537 2.306 2.306 1.537-1.538 1.538 1.538 2.305-2.306-1.537-1.537L15.294 11Z"
}));
FlagOM.displayName = 'FlagOM';
export default withFlagWrapper(FlagOM);
//# sourceMappingURL=index.js.map